// El mantenedor que muestra cada función del menú Configuración (docs/108 B10).
import { ArbolCategorias } from './ArbolCategorias';
import { CostoLogistico } from './CostoLogistico';
import { FormatoFactura } from './FormatoFactura';
import { ListasPrecio } from './ListasPrecio';
import {
  ApiKeys,
  Auditoria,
  Bodegas,
  Empresas,
  Impuestos,
  Marcas,
  Parametros,
  Vendedores,
  Zonas,
} from './Maestros';
import { Politicas } from './Politicas';
import { MaestroProductos } from './Productos';
import { Permisos, Roles, Usuarios } from './Seguridad';

export function PantallaConfig({ maestro, foco }: { maestro: string; foco?: string | undefined }) {
  switch (maestro) {
    case 'productos':
      return <MaestroProductos foco={foco as 'presentaciones' | 'codigos' | undefined} />;
    case 'categorias':
      return <ArbolCategorias />;
    case 'marcas':
      return <Marcas />;
    case 'listas':
      return <ListasPrecio foco={foco as 'escalas' | undefined} />;
    case 'vendedores':
      return <Vendedores />;
    case 'zonas':
      return <Zonas />;
    case 'costo-logistico':
      return <CostoLogistico />;
    case 'formato-factura':
      return <FormatoFactura />;
    case 'politicas':
      return <Politicas foco={foco as 'condiciones' | 'aprobaciones' | undefined} />;
    case 'impuestos':
      return <Impuestos />;
    case 'bodegas':
      return <Bodegas />;
    case 'empresas':
      return <Empresas />;
    case 'usuarios':
      return <Usuarios />;
    case 'roles':
      return <Roles />;
    case 'permisos':
      return <Permisos />;
    case 'parametros':
      return <Parametros />;
    case 'api-keys':
      return <ApiKeys />;
    case 'auditoria':
      return <Auditoria />;
    default:
      return <p className="pantalla apagado">Mantenedor desconocido: {maestro}</p>;
  }
}
